__webpack_require__.p = "/bhoomi/";